import { BookOpen, Clock, Flame, Target } from './Icons';
import { type Report } from '@mastery/api-client-web';
import { percent } from '../lib/shared';

export function Stats({ report }: { report?: Report }) {
  const metrics = [
    {
      icon: Target,
      label: '首次作答正确率',
      value: report?.first_answers ? percent(report.accuracy) : '—',
      note: report ? report.first_answers + ' 个客观题样本' : '正在读取',
    },
    {
      icon: BookOpen,
      label: '已完成练习',
      value: report?.completed_attempts ?? '—',
      unit: '次',
      note: '最近 90 天',
    },
    {
      icon: Clock,
      label: '累计学习',
      value: report?.study_minutes ?? '—',
      unit: '分钟',
      note: '最近 90 天',
    },
    { icon: Flame, label: '连续学习', value: report?.streak ?? '—', unit: '天', note: '截至今天' },
  ];
  return (
    <div className="stats" aria-label="学习数据">
      {metrics.map(({ icon: Icon, label, value, unit, note }) => (
        <div className="stat" key={label}>
          <div>
            <Icon size={17} />
            <span>{label}</span>
          </div>
          <strong>
            {value}
            {unit && <span>{unit}</span>}
          </strong>
          <small>{note}</small>
        </div>
      ))}
    </div>
  );
}
